/**
 * Support.js
 *
 * This file contains all the route under Support
 */

import View from '@/components/componentView.vue';
import ContactUs from '../views/Support/ContactUs.vue';
import ContactUsConfirmation from '../views/Support/ContactUsConfirmationPage.vue';

import { CONTACT_US, CONTACT_US_CONFIRMATION, HOME } from './routeNames';

export default [
  {
    path: 'support',
    component: View,
    meta: {
      title: 'Support',
      isCategory: true,
    },
    children: [
      {
        path: '',
        redirect: {
          name: HOME,
        },
      },
      {
        path: 'contact-us',
        component: View,
        meta: {
          title: 'Contact us',
        },
        children: [
          {
            path: '',
            name: CONTACT_US,
            component: ContactUs,
            meta: {
              title: 'Contact us',
            },
          },
          {
            path: 'confirmation',
            name: CONTACT_US_CONFIRMATION,
            component: ContactUsConfirmation,
            meta: {
              title: 'Thank you for contacting us',
            },
          },
        ],
      },
    ],
  },
];
